import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Navbar8 from '../components/navbar8'
import ContactForm7 from '../components/contact-form7'
import Footer4 from '../components/footer4'
import './contact.css'

const Contact = (props) => {
  return (
    <div className="contact-container">
      <Helmet>
        <title>CAIC: Contact Us</title>
        <meta
          property="og:title"
          content="CAIC: Contact Us"
        />
      </Helmet>
      <Navbar8
       
      ></Navbar8>
      <ContactForm7
        email={
          <Fragment>
            <span className="contact-text25 thq-body-small">
              caic@commonwealth.int
            </span>
          </Fragment>
        }
        phone={
          <Fragment>
            <span className="contact-text26 thq-body-small">
              +44 20 7747 6500
            </span>
          </Fragment>
        }
        action={
          <Fragment>
            <span className="contact-text27 thq-body-small">Contact us</span>
          </Fragment>
        }
        address={
          <Fragment>
            <span className="contact-text28 thq-body-small">
              <span>
                Marlborough House, Pall Mall, St. James&apos;s,
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>London, United Kingdom, SW1Y 5HX</span>
            </span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="contact-text32 thq-body-small">
              <span>
                Have a question or want to learn more about the Commonwealth AI
                Consortium?
              </span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </span>
          </Fragment>
        }
        content2={
          <Fragment>
            <span className="contact-text35 thq-body-small">
              We are here to help and look forward to hearing from you.
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="contact-text36 thq-heading-2">Contact Us</span>
          </Fragment>
        }
      ></ContactForm7>
      <Footer4
        
      ></Footer4>
    </div>
  )
}

export default Contact
